import styled from 'styled-components';

export const PickerWithSliderWrapper = styled.div`
  padding-top: 15px;
`
export const PickerWithSliderTitle = styled.div`
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const CheckboxBlockWrapper = styled.div`
  display: flex;

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #7cbe7b !important;
    border-color: #7cbe7b !important;
    outline: #7cbe7b !important;
  }
  .ant-checkbox-checked .ant-checkbox-inner::after {
    border-color: #fff !important;
    outline: #7cbe7b !important;
  }
`

export const BottomButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`